import { IPart } from "../../../models/Part";
import PriceFormat from '../../../utils/priceFormat';
import { DateTime } from "luxon";

interface LastSoldPriceButtonProps {
  parts: IPart[];
  onPriceSelect: (price: number) => void;
  lastSoldPrice?: number | null; // Optional: use aggregate lastSoldPrice when parts aren't loaded
}

export default function LastSoldPriceButton({ parts, onPriceSelect, lastSoldPrice }: LastSoldPriceButtonProps) {
  // If lastSoldPrice is provided (from aggregate), use it directly
  // Otherwise, calculate from parts array
  const suggestedPrice = lastSoldPrice !== undefined && lastSoldPrice !== null
    ? lastSoldPrice
    : parts.sort((a, b) => {
        if (!a.soldDate && !b.soldDate) return 0; // If both are not sold, keep original order
        if (!a.soldDate) return 1; // If a is not sold, b comes first
        if (!b.soldDate) return -1; // If b is not sold, a comes first
        const aDate = a.isInternal ? DateTime.fromISO(a.soldDate).toMillis() : DateTime.fromISO(a.created).toMillis();
        const bDate = b.isInternal ? DateTime.fromISO(b.soldDate).toMillis() : DateTime.fromISO(b.created).toMillis();
        return bDate - aDate;
      }).find((part: IPart) => part.soldDate)?.price || 0;

  return (
    <button
      onClick={() => onPriceSelect(suggestedPrice)}
      className="border text-white shadow rounded-md p-1 px-2 bg-primary-600 hover:bg-primary-500 w-20 text-center"
    >
      <span className="font-bold">{PriceFormat(suggestedPrice)}</span>
    </button>
  );
} 